import Image from "next/image";
import Link from "next/link";
import { FC, ReactNode } from "react";

interface Props {
  title: string;
  description: string;
  src: string;
  href: string;
  ariaLabel?: string;
  note?: ReactNode;
}
export const FunctionItem: FC<Props> = ({
  title,
  description,
  src,
  note,
  href,
  ariaLabel,
}) => {
  return (
    <article className="relative grid gap-8">
      <div className="relative grid gap-8 bg-white justify-items-start rounded-xs shadow-lg p-16 w-full">
        <div className="grid gap-4">
          <h1 className="font-bold justify-self-center">{title}</h1>
          <p className="text-sm leading-loose">{description}</p>
        </div>
        <div className="order-first relative aspect-video w-full">
          <Image
            className="object-cover object-center"
            alt={title}
            src={src}
            fill
            unoptimized
          />
        </div>

        <Link className="absolute inset-0" href={href} aria-label={ariaLabel} />
      </div>
      {note && <small>＊{note}</small>}
    </article>
  );
};
